var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckSuccess = function SvgCheckSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 8,
    fill: "#36A195"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.26 5.503a.889.889 0 0 0-1.257 0L6.817 9.689 5.142 8.015a.889.889 0 0 0-1.257 1.257l2.235 2.235a.89.89 0 0 0 .959.291.885.885 0 0 0 .416-.273L12.26 6.76a.889.889 0 0 0 0-1.257Z",
    fill: "#fff"
  })));
};

export default SvgCheckSuccess;